import type { Axios } from "axios";
import type { UseQueryOptions } from "@tanstack/react-query";
import type { CommunityInList } from "@/models";

export const getAllCommunities = async (
  axiosInstance: Axios
): Promise<CommunityInList[]> => {
  try {
    const response = await axiosInstance.get<CommunityInList[]>(`/communities`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching communities:`, error);
    throw error;
  }
};

export const getAllCommunitiesQuery = (
  axiosInstance: Axios
): UseQueryOptions<CommunityInList[]> => ({
  queryKey: ["communities"],
  queryFn: () => getAllCommunities(axiosInstance)
});
